import CompanyInformation from "../company-information"
import { translate } from "../utils/translations/translate"

global.executions.addLine({className: "<global>",functionName: undefined,hierarchy: ["/shared/translations/en_gb.ts", "<global>"],fileName: "/shared/translations/en_gb.ts",childLine: 4,line: "const en_gb = {"});
const en_gb = {
    backend: {
        errors: {
            default: {
                internalServerError: translate(
                    "Something went wrong on our end. We're working to fix it as soon as possible. Please try again later."
                ),
                clientSideError: translate(
                    "Something went wrong on your end. Please check your input and try again."
                ),
                serverOffline: translate(
                    "Our servers are currently down. We're aware of the issue and working to restore service as soon as possible."
                ),
                notAuthorized: translate(
                    `You are not authorized to perform this action.`
                ),
                badRequest: translate(
                    `The request is not of the right format.`
                )
            },
            backlogItemCategoryResolver: {
                addNewBacklogItemCategory: {
                    title: translate(`The title must be between 1 and 256 characters.`)
                }
            },
            backlogItemResolver: {
                item: {
                    notFound: translate(`The backlog item could not be found.`)
                },
                getBacklogItems: {
                    notFound: translate(`The category could not be found.`)
                },
                addNewBacklogItem: {
                    title: translate(`The title must be between 1 and 256 characters.`),
                    noParent: translate(`The parent or category could not be found.`)
                }
            },
            userResolver: {
                authorize: {
                    wrongCombination: translate(
                        `The email address and password do not match.`
                    )
                },
                register: {
                    localeInvalid: translate(
                        `The selected locale "$locale" is not supported. Please choose a valid option.`
                    ),
                    themeInvalid: translate(
                        `The theme "$theme" is not available. Please select a different one.`
                    ),
                    agreeToTerms: translate(
                        "To continue using our platform, please review and agree to our terms of service and privacy policy."
                    ),
                    emailInUse: translate(
                        "This email is already registered. Try logging in or using a different email."
                    ),
                    couldntGenerateSalt: translate(
                        "We encountered an issue while securing your account. Please try again."
                    ),
                    couldntHashPassword: translate(
                        "We couldn't process your password at the moment. Please try again."
                    ),
                    couldntSendMail: translate(
                        "We couldn't send the email due to a server issue. Please try again later."
                    )
                }
            }
        }
    },    
    components: {
        router: {
            routeNotFound: translate('The route at path "$route" could not be found.')
        }
    },
    document: {
        title: {
            main: translate(`${CompanyInformation.name}`),
            prefix: {
                login: {
                    forms: {
                        login: translate('Login'),
                        register: translate('Register')
                    }
                }
            }
        }
    },
    emails: {
        templates: {
            activateYourAccount: {
                subject: translate(`Welcome to ${CompanyInformation.name}`),
                template: {
                    title: translate(`Welcome to ${CompanyInformation.name}`),
                    sections: {
                        one: {
                            paragraphs: {
                                one: translate(`Hi, $fullName! Welcome to <b>${CompanyInformation.name}</b>! To complete your registration, please activate your account.`),
                                two: translate(`Click the button below to activate your account and get started with our platform.`),
                            },
                            buttons: {
                                activateAccount: translate('Activate Account')
                            }
                        }
                    }
                }
            },
        },
        alts: {
            callUs: translate('Call us'),
            mailUs: translate('Mail us'),
            logo: translate('Logo'),
            icon: translate('Icon')
        },
        footer: {
            copyright: translate('Copyright'),
            allRightsReserved: translate('All rights reserved.'),
        }
    },
    general: {
        greeting: translate('Hi'),
        modes: {
            dark: translate('dark'),
            light: translate('light')
        }
    },
    locales: {
        nl_NL: translate('Dutch'),
        en_GB: translate('English')
    },
    pages: {
        login: {
            forms: {
                login: {
                    title: translate("Login"),
                    description: translate("Please enter your account details to continue"),
                    controls: {
                        email: {
                            label: translate('Email')
                        },
                        password: {
                            label: translate('Password')
                        },
                        rememberMe: {
                            label: translate('Remember me')
                        },
                        forgotPassword: {
                            label: translate('Forgot password')
                        }
                    },
                    buttons: {
                        login: translate('Login'),
                        or: translate('or'),
                        google: translate('Sign in with Google')
                    },
                    register: {
                        label: translate('Not registered yet?'),
                        button: translate('Create an Account')
                    }
                },
                register: {
                    title: translate("Register"),
                    description: translate("Make your app management easy and fun!"),
                    controls: {
                        fullName: {
                            label: translate("Full Name"),
                            placeholder: translate("Enter your full name here")
                        },
                        email: {
                            label: translate("Email"),
                            placeholder: translate("Enter your email here")
                        },
                        password: {
                            label: translate("Password"),
                            placeholder: translate("Enter your password here")
                        },
                        agreement: {
                            label: translate("I agree to the"),
                            privacyPolicy: translate("privacy policy"),
                            and: translate("&"),
                            terms: translate("terms")
                        }
                    },
                    buttons: {
                        register: translate("Register"),
                        or: translate('or'),
                        google: translate('Sign in with Google')
                    },
                    login: {
                        label: translate("Already have an account?"),
                        button: translate("Login here")
                    }
                }
            },
            banner: {
                title: translate('Where Strategy Meets Simplicity')
            }
        }
    },
    tooltips: {
        topBar: {
            theme: translate(`Switch to $mode mode`),
            locale: translate('Select another language'),
            navigateBack: translate('Return to previous page')
        }
    },
    validation: {
        noTrailingSpacesStart: translate('There are trailing spaces at the start of the input'),
        noTrailingSpacesEnd: translate('There are trailing spaces at the end of the input'),
        minLength: translate('The min length for this input is $minLength {character|characters}'),
        maxLength: translate('The max length for this input is $maxLength {character|characters}'),
        mustBeChecked: translate('This checkbox must be checked'),
        mustBeUnchecked: translate('This checkbox may not be checked'),
        username: translate('The username is not of a correct format'),
        fullName: translate('The full name is not of a correct format'),
        email: translate('The email address is not of a correct format'),
        lowercase: translate('The value must contain a lowercase character'),
        uppercase: translate('The value must contain an uppercase character'),
        special: translate('The value must contain a special character'),
        number: translate('The value must contain a numeric character'),
    }
}

export default en_gb